import { render, staticRenderFns } from "./ComissaoAcoes.vue?vue&type=template&id=d730cd28"
import script from "./ComissaoAcoes.vue?vue&type=script&lang=js"
export * from "./ComissaoAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports